import {Component, OnInit, Inject} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Router} from '@angular/router';
import {ApiService, MessagesService} from '@angular/synthrone-design/services';
import {APP_CONFIG} from '@synthroneApp/app.config';
import {MatDialog} from '@angular/material';
import {AttributesGroupModel} from "@synthroneApp/models/attributesgroup/attributesgroup.model";

@Component({
    selector: 'app-attributes-groups-add-view',
    templateUrl: './attributes-groups-add-view.component.html',
    styleUrls: ['./attributes-groups-add-view.component.scss']
})

export class AttributesGroupsAddViewComponent implements OnInit {

    dataId: number;
    isLoading = true;
    actionName: string;
    public attributes: any[];
    public attributesGroup: AttributesGroupModel;
    isDataLoading = false;
    clients = [];

    constructor(private _router: Router, protected api: ApiService,
                private messagesService: MessagesService, @Inject(APP_CONFIG) private config, protected dialog: MatDialog) {
        this.actionName = (this._router.url.includes('add') ? 'Add' : 'Edit');
    }

    ngOnInit() {
        this.attributesGroup = {
            name: '',
            client: null,
            attributes: []
        };

        this.attributes = [];
        this.api.makeRequest('api_system_attribute_list', {
            seed: new Date().getTime()
        }, 'crafter').subscribe(
            (result) => {
                this.attributes = result['data'];
            },
            (error) => {
                this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result => {
                    this.homeReturnFN();
                });
            }
        );

        this.api.makeRequest('api_system_client_list', {}, 'crafter').catch(
            (err: any) => {
                const errorMsg = err || 'Could not get list of clients';
                return Observable.throw(errorMsg)
            }).subscribe(
            (clientsResult: any) => {
                this.clients = clientsResult.data;
            },
            (error) => {
                this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result3Err => {
                    this.homeReturnFN();
                });
            });

        if (this.actionName === 'Edit') {
            this.dataId = parseInt((this._router.url).match(/\d+/)[0]);
                this.api.makeRequest('api_system_attribute_group_details', {
                id: this.dataId
            }, 'crafter').subscribe(
                (result) => {
                    let parsedAttributes = result['attributes'].map(function (attribute) { return attribute['id'] });
                    this.attributesGroup = {
                        name: result['name'].toString(),
                        client: result['client']['id'],
                        attributes: parsedAttributes
                    };
                    this.isLoading = false;
                },
                (error) => {
                    this.isLoading = false;
                    this.messagesService.showSnack(error, 'error').afterDismissed().subscribe(result => {
                        this.homeReturnFN();
                    });
                });
        } else {
            this.isLoading = false;
        }
    }

    homeReturnFN = () => {
        this._router.navigate(['/attributes-groups']);
    };

    createOrgFN = () => {
        this.api.makeRequest('api_system_attribute_group_create', {
            'jsonPayload': this.attributesGroup
        }, 'crafter').subscribe(
            (result) => {
                this.isLoading = false;
                this.homeReturnFN();
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    };

    editOrgFN = () => {
        this.isLoading = true;
        this.api.makeRequest('api_system_attribute_group_put', {
            id: this.dataId,
            'jsonPayload': this.attributesGroup
        }, 'crafter').subscribe(
            (result) => {
                this.isLoading = false;
                this.homeReturnFN();
            },
            (error) => {
                this.isLoading = false;
                this.messagesService.showSnack(error, 'error');
            });
    };

    submitFN(isValid: boolean) {
        if (this.actionName === 'Add') {
            this.createOrgFN();
        } else {
            this.editOrgFN();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/views/attributes-groups-add-view/attributes-groups-add-view.component.ts